export const eventDateTimeFormat = 'MMM D  h:mm a';
export const eventHourFormat = 'h:mm a';
export const dateFormat = 'D MMM YYYY';
